
































































import { Component } from "vue-property-decorator";
import { FaqsService, FaqNovo } from "@/services/faqs.service";
import Confirm from "@/shared/components/confirm.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import WysiwygEditor from "@/shared/components/wysiwyg-editor.vue";
import ComboTopicos from "./ComboTopicos.vue";
import { required, tamCampo } from "@/shared/validators";

@Component({
  components: {
    WysiwygEditor,
    Confirm,
    ComboTopicos,
  },
})
export default class NovoFaq extends mixins(GlobalMixin) {
  filtro: FaqNovo = {
    idFaq: null,
    pergunta: "",
    descricao: "",
    resposta: "",
    ativo: false,
    topicos: [],
  };

  loading = false;

  rules = {
    pergunta: [required()],
    descricao: [required()],
    topicos: [required(), tamCampo(1, "Selecione pelo menos 1 tópico")],
  };

  async mounted() {
    let dump = 0;
    if (
      this.$route.params.id &&
      !Number.isNaN((dump = +this.$route.params.id))
    ) {
      this.loading = true;
      this.filtro = await FaqsService.Obter(dump).finally(
        () => (this.loading = false)
      );
    }
  }

  salvarFaq() {
    const form = this.$refs.form as any;
    const editor = this.$refs.editor as any;
    if (form.validate() && editor.validate()) {
      this.startLoader();
      FaqsService.Manter(this.filtro).then(this.voltar).finally(this.stopLoader);
    }
  }

  voltar() {
    this.$router.push({
      name: "faqs",
    });
  }
}
